// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__obUb7","inputDescription":"styles_inputDescription__2T9hP"};